<template>
  <modal
    name="milestone-modal"
    width="90%"
    height="90%"
    @before-open="getMilestones()"
  >
    <div class="header-actions">
      <Button
        class="close ma-3"
        @click.native="$modal.hide('milestone-modal')"
        margin="0px"
        color="#31b9be"
        bgcolor="transparent"
        width="30px"
        padding="0px"
        icon="close-blue"
      ></Button>
    </div>
    <div class="title-row my-3">
      <h3 class="title-row__title">{{ $t("general.milestone.select") }}</h3>
      <Button
        v-if="userHasTranslation"
        class="translate"
        @click.native="toggleTitleTranslation"
        :disabled="loadingTranslation"
        title
        shadow="true"
        color="#00A9B3"
        :bgcolor="showTranslation ? '#F3BDBF' : '#D9F0EA'"
        height="44"
        width="44px"
        margin="0px"
        padding="0px"
        icon="translate"
      ></Button>
    </div>
    <ListItem
      style="color: #E05484;"
      :highlighted="true"
      :last="true"
      @click.native="
        $modal.hide('milestone-modal');
        $modal.show('create-milestone-modal');
      "
    >
      <span
        style="width:24px; height: 24px; margin: 0 4px; display: inline-block; vertical-align: middle; text-align: center; line-height:24px; border: 1px solid #E05484; border-radius: 12px;"
      >+</span
      >
      <span>{{ $t("general.milestone.presets.action-add") }}</span>
    </ListItem>
    <ListItem
      v-for="milestone in milestones"
      :key="milestone.id"
      @click.native="
        $emit('select', milestone);
        $modal.hide('milestone-modal');
      "
    >
      <img
        :src="require(`@/assets/icons/${milestone.icon}`)"
        width="32"
        height="32"
      />
      <span>{{ getMilestoneTitle(milestone) }}</span>
    </ListItem>
  </modal>
</template>

<script>
import { neoparentPosts } from "@/api";

export default {
  name: "MilestoneModal",
  data() {
    return {
      milestones: [],
      showTranslation: false,
      loadingTranslation: false,
      titleTranslations: {}
    };
  },
  computed: {
    userHasTranslation() {
      const user = this.$store.getters.user;
      const hasDeepl = !!(user && user.hospital && user.hospital.hasDeepl);

      if (!hasDeepl || !user) {
        return false;
      }

      if (user.role !== 'p') {
        return true;
      }

      return !!user.translationLanguage;
    }
  },
  methods: {
    getMilestoneTitle(milestone) {
      if (!milestone) {
        return "";
      }

      if (!this.showTranslation) {
        return milestone.title;
      }

      const key = milestone.id;
      return (this.titleTranslations && this.titleTranslations[key]) || milestone.title;
    },
    getMilestones() {
      this.showTranslation = false;
      this.loadingTranslation = false;
      this.titleTranslations = {};

      neoparentPosts
        .getMilestones(this.$store.getters.patient.id)
        .then(result => {
          this.consoleLog(result);
          this.milestones = result.data.milestones;
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    async toggleTitleTranslation() {
      this.showTranslation = !this.showTranslation;

      if (Object.keys(this.titleTranslations || {}).length > 0 || !this.showTranslation) {
        return;
      }

      this.loadingTranslation = true;
      try {
        const res = await neoparentPosts.translateMilestoneTitles(this.$store.getters.patient.id);
        this.titleTranslations = res.data.titleTranslations || {};
      } catch (err) {
        this.showTranslation = false;
        this.consoleLog(err);
      } finally {
        this.loadingTranslation = false;
      }
    }
  }
};
</script>

<style scoped>
ul {
  flex-direction: column;
  display: flex;
}

li {
  padding: 1rem 0rem;
}

ul :not(:last-child) {
  border-bottom: 1px solid #31b9be;
}

h3 {
  margin-right: 20px;
  margin-left: 20px;
}

.header-actions {
  display: flex;
  align-items: center;
}

.title-row {
  display: flex;
  align-items: center;
}

.title-row__title {
  margin: 0 8px 0 20px;
}

ul {
  margin-top: 4rem;
}

img {
  width: auto;
  vertical-align: middle;
}

a,
a:hover {
  text-decoration: none;
  color: #222;
}
</style>
